(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodScrollTo', sodScrollTo);

    function sodScrollTo(lodash) {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs) {
                elem.on('click', scrollToListener);

                var toElem = lodash.get(attrs, 'toElem');
                var offset = lodash.get(attrs, 'offset');

                function scrollToListener(event) {
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: ($('#' + toElem).offset().top) + (parseInt(offset) || 0)
                    }, 500);
                }
                scope.$on('$destroy', function () {
                    elem.off('click', scrollToListener);
                })
            },
        };
    }
})();